module.exports = require('./lib').default;
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/radium/index.js
// module id = 44
// module chunks = 0